import {
  AdoptionIcon,
  AssistedReproductionIcon,
  FertilityIcon,
  GenderAffirmingCareIcon,
  GestationalSurrogacyIcon,
  LowTestosteroneIcon,
  MenopauseIcon,
  ParentingIcon,
  PregnancyIcon,
  PreservationIcon,
  SvgIcon
} from "@carrotfertility/carotene-core"
export const iconNameToComponent: Record<string, typeof SvgIcon> = {
  Adoption: AdoptionIcon,
  "Assisted Reproduction": AssistedReproductionIcon,
  Fertility: FertilityIcon,
  "Gender Affirming Care": GenderAffirmingCareIcon,
  "Gestational Surrogacy": GestationalSurrogacyIcon,
  "Low Testosterone": LowTestosteroneIcon,
  Menopause: MenopauseIcon,
  Parenting: ParentingIcon,
  Pregnancy: PregnancyIcon,
  Preservation: PreservationIcon
}
